<template>
    <div>
        <CostableTableWithSelectedDropdown />
        <CostableTableWithSelectedChangeMultipleModal />
        <CostableTableWithSelectedChangeStatusModal />
        <CostableTableWithSelectedChangeQuantityModal />
        <CostableTableWithSelectedChangeSupplierModal />
        <CostableTableWithSelectedChangeDiscountModal />
        <CostableTableWithSelectedChangeCommissionModal />
        <CostableTableWithSelectedChangeUnitCostModal />
        <CostableTableWithSelectedChangeUnitPriceModal />
        <CostableTableWithSelectedChangeManagementFeeModal />
        <CostableTableWithSelectedChangeTaxRateModal />
        <CostableTableWithSelectedChangeUserModal />
    </div>
</template>

<script>
import CostableTableWithSelectedChangeTaxRateModal from '@/modules/costable/_components/CostableTableWithSelectedChangeTaxRateModal';
import CostableTableWithSelectedChangeUserModal from '@/modules/costable/_components/CostableTableWithSelectedChangeUserModal';
import CostableTableWithSelectedDropdown from './CostableTableWithSelectedDropdown';
import CostableTableWithSelectedChangeStatusModal from './CostableTableWithSelectedChangeStatusModal';
import CostableTableWithSelectedChangeMultipleModal from './CostableTableWithSelectedChangeMultipleModal';
import CostableTableWithSelectedChangeQuantityModal from './CostableTableWithSelectedChangeQuantityModal';
import CostableTableWithSelectedChangeSupplierModal from './CostableTableWithSelectedChangeSupplierModal';
import CostableTableWithSelectedChangeDiscountModal from './CostableTableWithSelectedChangeDiscountModal';
import CostableTableWithSelectedChangeCommissionModal from './CostableTableWithSelectedChangeCommissionModal';
import CostableTableWithSelectedChangeUnitCostModal from './CostableTableWithSelectedChangeUnitCostModal';
import CostableTableWithSelectedChangeUnitPriceModal from './CostableTableWithSelectedChangeUnitPriceModal';
import CostableTableWithSelectedChangeManagementFeeModal from './CostableTableWithSelectedChangeManagementFeeModal';

export default {

    components: {
        CostableTableWithSelectedDropdown,
        CostableTableWithSelectedChangeMultipleModal,
        CostableTableWithSelectedChangeStatusModal,
        CostableTableWithSelectedChangeQuantityModal,
        CostableTableWithSelectedChangeSupplierModal,
        CostableTableWithSelectedChangeDiscountModal,
        CostableTableWithSelectedChangeCommissionModal,
        CostableTableWithSelectedChangeUnitCostModal,
        CostableTableWithSelectedChangeUnitPriceModal,
        CostableTableWithSelectedChangeManagementFeeModal,
        CostableTableWithSelectedChangeTaxRateModal,
        CostableTableWithSelectedChangeUserModal,
    },

};
</script>
